export default "__VITE_ASSET__438c6e70__"